import React from "react";

export const BUTTON_VARIANT_CLASSES = [
    "btn-clear",
    "btn-primary",
    "btn-accent",
    "btn-light",
    "btn-info",
    "btn-outline",
    "btn-primary-outline",
] as const;

export  const BUTTON_SIZES = ["btn-lg", "btn-md", "btn-sm", "btn-resize"] as const;


export type ButtonVariant = typeof BUTTON_VARIANT_CLASSES[number];
export type ButtonSize   = typeof BUTTON_SIZES[number];

export interface ButtonProps {
    children?: React.ReactNode;
    type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
    disabled?: boolean;
    variant?: ButtonVariant;
    size?: ButtonSize;
    property?: string;
    icon?: React.ReactNode;
    id?: string;
    title?: string;
    style?: React.CSSProperties;
}